import { useState, useEffect } from "react";

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState("visible"); // visible -> fading -> done

  useEffect(() => {
    const fadeTimer = setTimeout(() => setPhase("fading"), 400);
    const doneTimer = setTimeout(() => {
      setPhase("done");
      onComplete();
    }, 800);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onComplete]);

  if (phase === "done") return null;

  return (
    <div
      className={`fixed inset-0 z-[200] bg-[#050505] flex flex-col items-center justify-center transition-opacity duration-500 ${
        phase === "fading" ? "opacity-0" : "opacity-100"
      }`}
    >
      <div className="animate-splash-icon">
        <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border border-cyan-500/30 flex items-center justify-center mb-6 mx-auto shadow-lg shadow-cyan-500/10 overflow-hidden">
          <img src="/icons/icon-192.png" alt="" className="w-12 h-12 object-contain" onError={(e) => {
            e.target.style.display = "none";
            e.target.parentElement.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="w-10 h-10 text-cyan-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"/><path d="m3 7 9 6 9-6"/></svg>';
          }} />
        </div>
      </div>
      <h1 className="font-mono text-2xl font-bold animate-splash-text">
        <span className="text-zinc-600">&lt;</span>
        <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">ShadowMail</span>
        <span className="text-zinc-600"> /&gt;</span>
      </h1>
      <div className="mt-6 w-12 h-0.5 bg-zinc-800 rounded-full overflow-hidden">
        <div className="h-full bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 animate-splash-bar rounded-full" />
      </div>
    </div>
  );
}
